export enum SetClipsType {
  default = 'default',
  myFavourites = 'my_favourites',
  otherFavourites = 'other_favourites',
  community = 'community',
  closedCommunity = 'closedCommunity',
}

export interface Tab {
  id: number;
  name: string;
  key?: string;
}

export interface VideoTabLocationState {
  videoTab: number;
  verticalScroll: number;
  horizontalScroll: number;
}
